import api from '../../api'
import {
  GET_SALARY_LIST_SUCCESS,
  GET_SALARY_LIST_FAILURE,
  GET_SALARY_FAILURE,
  GET_SALARY_SUCCESS,
  UPDATE_SALARY_SUCCESS,
} from '../types'

const state = {
  list: [],
  listUpdated: (new Date()),
  toValidateList: [],
  selected: null,
  selectedUpdated: (new Date())
};


const actions = {

  
  getSalaryList({commit}, query) {
    return new Promise((resolve, reject) => {

    api.startLoader()
    api.getSalaryList(query).then(response => {
      if (!response.ok) {
        api.stopLoader()
        return commit(GET_SALARY_LIST_FAILURE)
        return reject(response.body.$error)

      }
      commit(GET_SALARY_LIST_SUCCESS, {
        salaryList: response.body.data
      })
      api.stopLoader()
      return resolve(response.body.data)

    }, response => {
      api.stopLoader()
      commit(GET_SALARY_LIST_FAILURE)
      return reject(response.body.$error)

    })
  })
  },
 
  cleanSalaryList({commit}) {
    return commit(GET_SALARY_LIST_FAILURE)
  },
  
  getSalary({commit}, ud) {
    return new Promise((resolve, reject) => {

      api.getSalary(ud)
        .then(response => {
          console.log(response);
          if (!response.ok) {
            commit(GET_SALARY_FAILURE);
            reject();
          }
          commit(GET_SALARY_SUCCESS, {
            salary: response.body
          });
          resolve(response.body);
        }, response => {
          commit(GET_SALARY_FAILURE);
          reject();
        })
    })
  },
 
  
  updateSalary({commit}, data) {
    return new Promise((resolve, reject) => {

      if(data.formattedValueCentavos != undefined){
        data.valueCentavos = parseInt(("" + data.formattedValueCentavos).onlyNumber())
      }

      if(data.valueFactor != undefined){
        data.formattedValueFactor = data.valueFactor+"%"
      }

      api.startLoader()
      let avaliables = [
        "id",
        "formattedValueFactor",
        "formattedValueCentavos",
        "valueFactor",
        "valueCentavos",
        "SalaryTypeId"
      ];

      let obj = {};

      for (let i of avaliables) {
        if (data.hasOwnProperty(i)) {
          obj[i] = data[i];
        }
      }

          api.updateSalary(obj)
            .then(response => {
              if (!response.ok) {
                api.stopLoader()
                return reject(response.body.$error);
              } else {
                api.stopLoader()
                return resolve(response.body.$success);
              }
            }, response => {
              api.stopLoader()
              return reject(response.body.$error);
            })
      
    })
  },
  createSalary({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()

      if(data.formattedValueCentavos != undefined){
        data.valueCentavos = parseInt(("" + data.formattedValueCentavos).onlyNumber())
      }

      if(data.valueFactor != undefined){
        data.formattedValueFactor = data.valueFactor+"%"
      }
      
      api.createSalary(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          } else {
            api.stopLoader()
            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })
    })
  },
  
  
 
  deleteSalary({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.deleteSalary(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          } else {
            api.stopLoader()
            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })
    })
  },

  
  
};

const mutations = {

  [UPDATE_SALARY_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.salary));
  },
  [GET_SALARY_LIST_FAILURE](state) {
    state.list = []
  },
  [GET_SALARY_LIST_SUCCESS](state, action) {
    state.list = action.salaryList;
    state.listUpdated = new Date();
  },
  [GET_SALARY_FAILURE](state) {
    state.selected = null
  },
  [GET_SALARY_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.salary));
  },
};

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/salary.js